import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IApplicationState } from '../../../store';
import { SurveyHelper } from '../../../utilities';
import { SurveyAdditionalLanguages } from './SurveyAdditionalLanguages';
import { SurveyDefaultLanguage } from './SurveyDefaultLanguage';

const EnabledLanguagesContainer = styled.div`
	font-size: 1rem;
	font-weight: 700;
	margin: 30px 0 30px 0;
`;

export function SurveyLanguages() {
	const { availableCultures, culturesLoading } = useSelector((storeState: IApplicationState) => storeState.cultures);
	const { surveyEditModel } = useSelector((storeState: IApplicationState) => storeState.survey);

	const selectedDefaultCulture = SurveyHelper.getDefaultCulture(surveyEditModel.defaultCultureCode, availableCultures);
	const selectedAdditionalCultures = SurveyHelper.getSelectedAdditionalCultures(
		surveyEditModel.supportedCultures,
		surveyEditModel.defaultCultureCode,
		availableCultures,
	);
	const availableDefaultCultures = availableCultures.filter((ac) => !selectedAdditionalCultures.some((sac) => sac.name === ac.name));
	const availableAdditionalCultures = availableCultures.filter((ac) => ac.name !== selectedDefaultCulture.name);

	return (
		<>
			<EnabledLanguagesContainer>{ContentConstants.SUBSECTIONHEADERS_LANGUAGES}</EnabledLanguagesContainer>
			<SurveyDefaultLanguage
				availableDefaultCultures={availableDefaultCultures}
				culturesLoading={culturesLoading}
				selectedDefaultCultures={[selectedDefaultCulture]}
				surveyId={surveyEditModel.survey.surveyId}
			/>
			<SurveyAdditionalLanguages
				availableAdditionalCultures={availableAdditionalCultures}
				culturesLoading={culturesLoading}
				defaultCultureCode={surveyEditModel.defaultCultureCode}
				selectedAdditionalCultures={selectedAdditionalCultures}
			/>
		</>
	);
}
